import React, { useState } from "react";
import { Box, Typography, Button, Tab, Tabs } from "@mui/material";
import BaseDrawer from "../../components/UI/BaseDrawer/BaseDrawer";
import PinPasswordReset from "../TransferDrawer/TransferDrawerComponents/PinPasswordReset";
import AccountingModule from "./AdminCenterComponents/AccountingModule";
import BundleFeeModule from "./BundleFeeModule/BundleFeeModule";
import ExchangeFeeModule from "./ExchangeFeeModule/ExchangeFeeModule";
import ReEnableMFA from "./AdminCenterComponents/ReEnableMFA";
import { useSelector } from "react-redux";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            // aria-labelledby={`simple-tab-${index}`}
            {...other}
            className="tab-panel-container"
        >
        {value === index && (
            <Box sx={{ p: 3 }}>
                <Typography>{children}</Typography>
            </Box>
        )}
        </Box>
    );
}

function AdminCenter({ handleClose, isOpen }) {
    const [value, setValue] = useState(0);
    let isAdmin = sessionStorage.getItem("isAdmin");
    let isSuperAdmin = sessionStorage.getItem("isSuperAdmin");

    let configVariables = useSelector((state) => state.config.baseConfig);
    let userSecurityRoles = JSON.parse(sessionStorage.getItem("user"))?.payload?.body?.Securityuserrole;

    const userRoles = Array.isArray(userSecurityRoles) ? userSecurityRoles : [userSecurityRoles];

    const parseConfigIds = (ids) => ids?.toString().split(',').map(id => Number(id.trim())) || [];
    const adminRolesArray = parseConfigIds(configVariables?.portfolioAdminRoleIds);
    const isPortfolioAdmin = userRoles.some(
        role => adminRolesArray.includes(Number(role?.roleid))
    );

    // console.log("isPortfolioAdmin------------",isPortfolioAdmin);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
    <Box
        class="offcanvas offcanvas-end dynamic-offcanvas"
        tabindex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
    >
        <Box class="customer-bottom-info">
            <Box class="text-end p-2">
                <Button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                ></Button>
            </Box>
            <Box class="accordion" id="profileAccordion">
                <Box class="accordion-item">
                    <BaseDrawer
                        open={isOpen}
                        handleClose={handleClose}
                        height="80vh"
                    >
                        <Box sx={{ display: "flex", height: "100%" }}>
                            <Tabs
                                orientation="vertical"
                                variant="scrollable"
                                value={value}
                                onChange={handleChange}
                                sx={{
                                    borderRight: 1,
                                    borderColor: "divider",
                                    //indicator color
                                    "& .MuiTabs-indicator": {
                                        backgroundColor: "#ff972c",
                                    },
                                    //selected tabs
                                    "& .MuiButtonBase-root.Mui-selected": {
                                        color: "#ff972c",
                                    },
                                    //non selected tabs
                                    "& .MuiButtonBase-root": {
                                        color: "rgba(0, 0, 0, 0.87)",
                                    },
                                }}
                            >
                                <Tab label="Pin/Password Change" />
                                {isSuperAdmin === "true" && <Tab label="Accounting Module" />}
                                {/* {isSuperAdmin === "true" && <Tab label="Bundle Fee" />} */}
                                {isSuperAdmin === "true" && <Tab label="Exchange Rate" />}
                                {(isSuperAdmin === "true" || isPortfolioAdmin === true) && <Tab label="Reset MFA" />}
                            </Tabs>

                            <TabPanel value={value} index={0}>
                                <PinPasswordReset handleClose={handleClose} />
                            </TabPanel>
                            {isSuperAdmin === "true" && (
                                <TabPanel value={value} index={1}>
                                    <AccountingModule />
                                </TabPanel>
                            )}
                            {/* <TabPanel value={value} index={2}>
                                <BundleFeeModule />
                            </TabPanel> */}
                            {isSuperAdmin === "true" && (
                                <TabPanel value={value} index={2}>
                                    <ExchangeFeeModule />
                                </TabPanel>
                            )}

                            {(isSuperAdmin === "true" || isPortfolioAdmin === true) && (
                                <TabPanel value={value} index={isSuperAdmin === "true" ? 3 : 1}>
                                    <ReEnableMFA />
                                </TabPanel>
                            )}
                        </Box>
                    </BaseDrawer>
                </Box>
            </Box>
        </Box>
    </Box>);
}

export default AdminCenter;